export const seoContents = {
  "meta": [
    {
      page: "default",
      title: "Nick Siu's Personal Website",
      description: "Portfolio and Work Experience of a Software Engineer, QA Engineer, and Student",
      keywords: "portfolio, software, nick siu"
    },
    {
      page: "about",
      title: "Nick Siu | About",
      description: "Introduction to Nick Siu",
      keywords: "nick siu, about, Computer Science, University of British Columbia"
    },
    {
      page: "experience",
      title: "Nick Siu | Experience",
      description: "Work Experience of Nick Siu",
      keywords: "Nick Siu, Work Experience, Computer Science, Software Engineer, QA Engineer"
    },
    {
      page: "portfolio",
      title: "Nick Siu | Portfolio",
      description: "Portfolio of Nick Siu",
      keywords: "Portfolio, Github, Nick Siu, Calendar, Spotify"
    },
  ]
}